import styled from '@emotion/styled'
import { Link } from 'react-router-dom'

const RouterLink = styled(Link)`
  text-decoration: none;

  color: inherit;
`

export default RouterLink
